import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'ah-range-picker-popup',
  templateUrl: './range-picker-popup.component.html',
  styleUrls: ['./range-picker-popup.component.scss']
})
export class RangePickerPopupComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<RangePickerPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
    console.log(this.data);
  }

  datePickerChange(event){
    this.close(event)
  }

  close(event){
    this.dialogRef.close(event);
  }

}
